module.exports = __webpack_public_path__ + "img/005-sketchbook.e2862b65.svg";